import { BehaviorParameters } from 'rangeConfig/@types';
import { ErrorMessages, NightLightsSystem, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';

const autoFillLightsDropBehavior = ({
  coreApi,
  rootState: {
    products: { inMarket: products, selectedGroupId },
    layout: { darkScene }
  },
  props
}: BehaviorParameters) => {
  const productId =
    props.coreProductIds && props.coreProductIds.length > 0
      ? props.coreProductIds[0]
      : props.coreProductId;
  const lightProduct = products.find(p => p.coreProductId === productId);

  const isInnerLight =
    (lightProduct && lightProduct.type === ProductType.PAX_INNER_LIGHT) ||
    (lightProduct && lightProduct.type === ProductType.PAX_INNER_LIGHT_OVERSIDAN);

  const placementAttemptErrorMessage = !hideNoFramesInSceneErrorMessage(coreApi)
    ? ErrorMessages.NoFramesInScene
    : !isInnerLight
    ? ErrorMessages.NoRoomForOuterLights
    : null;
  if (placementAttemptErrorMessage) {
    coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
  }

  if (
    (lightProduct && lightProduct.type === ProductType.PAX_INNER_LIGHT) ||
    (lightProduct && lightProduct.type === ProductType.PAX_INNER_LIGHT_OVERSIDAN)
  ) {
    coreApi.products.addCluster(props.coreProductIds, props.position);
  } else {
    const frame = coreApi.entities.getEntityClosestToPosition(props.position, [
      ComponentIds.FRAME_COMPONENT_ID
    ]);
    if (!frame) return;

    coreApi.products.autoFillOuterLights(productId, [frame]);
  }

  if (!darkScene && selectedGroupId === 'lights') {
    const currentLightsInScene = coreApi.entities.getByComponent(ComponentIds.LIGHT_COMPONENT_ID);

    if (currentLightsInScene.length > 0) {
      coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.enable();
      coreApi.emit.onEnableNightMode(true);
    }
  }
};

export default autoFillLightsDropBehavior;
